<template>
    <PromotionComp />
</template>
<script lang="ts" setup>

import { defineAsyncComponent } from 'vue'
const PromotionComp = defineAsyncComponent(() => import('@/components/managementPages/PromotionPage/promotionComp.vue'));
</script>